import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { XYPlot, XAxis, YAxis, VerticalGridLines, HorizontalGridLines, VerticalRectSeries } from 'react-vis';

import Page from '../../shared/components/Page';

import { serverLoadValidationStatistics } from '../actions';

const timestamp = new Date('May 23 2017').getTime();
const ONE_DAY = 86400000;

const DATA = [
  {x0: ONE_DAY * 2, x: ONE_DAY * 3, y: 1},
  {x0: ONE_DAY * 7, x: ONE_DAY * 8, y: 1},
  {x0: ONE_DAY * 8, x: ONE_DAY * 9, y: 1},
  {x0: ONE_DAY * 9, x: ONE_DAY * 10, y: 2},
  {x0: ONE_DAY * 10, x: ONE_DAY * 11, y: 2.2},
  {x0: ONE_DAY * 19, x: ONE_DAY * 20, y: 1},
  {x0: ONE_DAY * 20, x: ONE_DAY * 21, y: 2.5},
  {x0: ONE_DAY * 21, x: ONE_DAY * 24, y: 1}
].map(el => ({x0: el.x0 + timestamp, x: el.x + timestamp, y: el.y}));

class ValidationStatistics extends Component{
    constructor(props){
        super(props);
    }

    componentDidMount(){
        this.props.serverLoadValidationStatistics();
    }

    render(){
        //const { props } = this;

        return(
            <Page>
                <Page.MainArea>
                    <div className="container-with-padding">
                        <h4 className="heading-level-1" style={{
                            marginBottom: 16,
                        }}>Validation Statistics</h4>
                        <div>
                            <XYPlot
                                xDomain={[timestamp - (2 * ONE_DAY), timestamp + (30 * ONE_DAY)]}
                                yDomain={[0, 1]}
                                xType="time"
                                width={700}
                                height={400} >
                                <VerticalGridLines />
                                <HorizontalGridLines />
                                <XAxis tickLabelAngle={-90} width={500} />
                                <YAxis />
                                <VerticalRectSeries data={DATA} style={{stroke: '#fff'}}/>
                            </XYPlot>
                        </div>
                    </div>
                </Page.MainArea>
            </Page>
        )
    }
}

ValidationStatistics.propTypes = {
    serverLoadValidationStatistics: PropTypes.func,
}

// Map props to the store

const mapStateToProps = () => ({
});
  
const mapDispatchToProps = (dispatch) => ({
    serverLoadValidationStatistics: () => {
        dispatch(serverLoadValidationStatistics());
    },
});
  
const ValidationStatisticsContainer = connect(mapStateToProps,mapDispatchToProps)(ValidationStatistics);

export default ValidationStatisticsContainer;


// WEBPACK FOOTER //
// ./src/admin/pages/ValidationStatistics.js